// Utils
import { flatten } from '..';
import { isBuffer, keyIdentity } from './flatUtils';
/**
 * Following code is a copy from 'flat' library (v5.0.2): @see https://github.com/hughsk/flat.
 * The modifications performed by us is neglible, and is only confined to TS support and ESLint compliance.
 * Note: we haven't reviewed the code to avoid spending time rewriting it.
 *
 * @param target the object to be flatten
 * @param {UnflattenOptions} opts extra options to perform flatten
 * @returns unflatten object
 */
// eslint-disable-next-line complexity
export var unflatten = function (target, opts) {
    opts = opts || {};
    var delimiter = opts.delimiter || '.';
    var overwrite = opts.overwrite || false;
    var transformKey = opts.transformKey || keyIdentity;
    var result = {};
    var isbuffer = isBuffer(target);
    if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
        return target;
    }
    // safely ensure that the key is an integer.
    var getkey = function (key) {
        var parsedKey = Number(key);
        return isNaN(parsedKey) || key.indexOf('.') !== -1 || opts.object ? key : parsedKey;
    };
    var addKeys = function (keyPrefix, recipient, targetObj) {
        return Object.keys(targetObj).reduce(function (resultObj, key) {
            resultObj[keyPrefix + delimiter + key] = targetObj[key];
            return resultObj;
        }, recipient);
    };
    var isEmpty = function (val) {
        var type = Object.prototype.toString.call(val);
        var isArray = type === '[object Array]';
        var isObject = type === '[object Object]';
        if (!val) {
            return true;
        }
        if (isArray) {
            return !val.length;
        }
        if (isObject) {
            return !Object.keys(val).length;
        }
        return false;
    };
    target = Object.keys(target).reduce(function (resultObj, key) {
        var type = Object.prototype.toString.call(target[key]);
        var isObject = type === '[object Object]' || type === '[object Array]';
        if (!isObject || isEmpty(target[key])) {
            resultObj[key] = target[key];
            return resultObj;
        }
        return addKeys(key, resultObj, flatten(target[key], opts));
    }, {});
    // eslint-disable-next-line complexity
    Object.keys(target).forEach(function (key) {
        var split = key.split(delimiter).map(transformKey);
        var key1 = getkey(split.shift());
        var key2 = getkey(split[0]);
        var recipient = result;
        while (key2 !== undefined) {
            if (key1 === '__proto__') {
                return;
            }
            var type = Object.prototype.toString.call(recipient[key1]);
            var isObject = type === '[object Object]' || type === '[object Array]';
            // do not write over falsey, non-undefined values if overwrite is false
            if (!overwrite && !isObject && typeof recipient[key1] !== 'undefined') {
                return;
            }
            if ((overwrite && !isObject) || (!overwrite && recipient[key1] == null)) {
                recipient[key1] = typeof key2 === 'number' && !opts.object ? [] : {};
            }
            recipient = recipient[key1];
            if (split.length > 0) {
                key1 = getkey(split.shift());
                key2 = getkey(split[0]);
            }
        }
        // unflatten again for 'messy objects'
        recipient[key1] = unflatten(target[key], opts);
    });
    return result;
};
//# sourceMappingURL=unflatten.js.map